/**
 * The software keyboard's height on the native shell (task 13.6), for
 * `chrome/keyboardInset.ts`. The adapter layer is the only place allowed to
 * import `@capacitor/*` (`__tests__/adapterBoundary.test.ts`); this is the
 * whole binding. Off-device it does nothing and never loads the plugin.
 */
import { Capacitor } from "@capacitor/core";

/** Calls `onHeight` with the keyboard's height as it shows, and 0 as it hides. */
export async function onKeyboardHeight(onHeight: (px: number) => void): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  const { Keyboard } = await import("@capacitor/keyboard");
  await Keyboard.addListener("keyboardWillShow", ({ keyboardHeight }) => onHeight(keyboardHeight));
  await Keyboard.addListener("keyboardWillHide", () => onHeight(0));
}
